import { useGetUser } from 'entities/user/api';
import { usePatchUser } from 'entities/user/api/hooks/usePatchUser';

/**
 * Custom hook to get current user data
 */
export const useUser = () => {
  /**
   * Get user data
   */
  const { data, isLoading, isInitialLoading } = useGetUser();

  /**
   * Update user data
   */
  const { mutateAsync: update } = usePatchUser();

  /**
   * Get user label
   */
  const label = `${data?.name} ${data?.surname}`;

  /**
   * Check if a user is logged
   */
  const isLogged = data !== undefined;

  return { data, label, update, isLoading, isInitialLoading, isLogged };
};
